module.exports = __webpack_public_path__ + "img/AldhairVeraIcon.0f1ae3b3.png";